<template>
  <div class="purchase-user-data">
    <AmTypography
      class="purchase-user-data__title"
      :class="`text--${theme.color}`"
      :text="$t('purchaseUserData.yourDatas')"
      typography-style="l5"
      weight="medium"
    />
    <div class="purchase-user-data__container">
      <div class="purchase-user-data__contact">
        <AmTypography
          class="purchase-user-data__contact-title"
          :text="$t('purchaseUserData.contact')"
          typography-style="l6"
          weight="medium"
        />
        <AmTypography
          :text="email"
          typography-style="l6"
        />
        <AmTypography
          :text="formaterPhone(telephone)"
          typography-style="l6"
        />
      </div>
      <div
        v-if="enableAddress"
        class="purchase-user-data__address"
      >
        <AmTypography
          class="purchase-user-data__address-title"
          :text="$t('purchaseUserData.deliveryAddress')"
          typography-style="l6"
          weight="medium"
        />
        <AmTypography
          :text="getFullAddressFirstPart()"
          typography-style="l6"
        />
        <AmTypography
          :text="getFullAddressSecondPart()"
          typography-style="l6"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseUserData',
  props: {
    email: {
      type: String,
    },
    telephone: {
      type: String,
    },
    city: {
      type: String,
    },
    street: {
      type: String,
    },
    number: {
      type: String,
    },
    district: {
      type: String,
    },
    complement: {
      type: String,
    },
    uf: {
      type: String,
    },
    postcode: {
      type: String,
    },
    enableAddress: {
      type: Boolean,
    },
    theme: {
      type: [String, Object],
    },
  },
  methods: {
    formaterPhone(phone) {
      const ddd = phone.slice(0, 2)
      const number = phone.slice(2, phone.length)

      return `(${ddd}) ${number}`
    },
    getFullAddressFirstPart() {
      return `${this.street}, ${this.number}`
    },
    getFullAddressSecondPart() {
      return `${this.district}, ${this.uf} ${this.postcode}`
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-user-data {
  &__title {
    margin-bottom: 4px;
  }
  &__container {
    border: 1px solid $light-40;
    border-radius: 4px;
  }
  &__contact,
  &__address {
    padding: 10px;
  }
  &__address {
    border-top: 1px solid $light-40;
  }
  &__contact-title,
  &__address-title {
    text-transform: capitalize;
    margin-bottom: 6px;
  }
}
</style>
